/** Which signal chose the locale applied at startup. */
export enum LocaleDetectionSource {
  QueryParam = "QUERY_PARAM",
  StoredChoice = "STORED_CHOICE",
  BrowserLanguage = "BROWSER_LANGUAGE",
  Default = "DEFAULT",
}
